import { TimerRemoveOutlineIcon } from './TimerRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id B4E196AF-73B9-4693-806F-1267ECA46EB6
 * name timer-remove-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-remove-outline.svg
 * tags
 * - Date / Time 
 */
export const StopwatchRemoveOutlineIcon = TimerRemoveOutlineIcon;
export default StopwatchRemoveOutlineIcon